module.exports = __webpack_public_path__ + "static/img/kefu.5e96bdb9.png";